var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 7,
    viewBox: "0 0 15 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3170_3193",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L7.5 7L15 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7L6.81768 7.73106C7.20189 8.08965 7.79811 8.08965 8.18232 7.73106L7.5 7ZM-0.682318 0.731055L6.81768 7.73106L8.18232 6.26894L0.682318 -0.731055L-0.682318 0.731055ZM8.18232 7.73106L15.6823 0.731055L14.3177 -0.731055L6.81768 6.26894L8.18232 7.73106Z",
    fill: "white",
    mask: "url(#path-1-inside-1_3170_3193)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.9da638739bfc7350b374bae3adca3be3.svg";
export { ForwardRef as ReactComponent };